/* eslint-disable react/style-prop-object */
import React, { useState, useRef, useEffect, startTransition } from 'react'
import Button from 'react-bootstrap/Button'
import Logo from '../../img/logo-tfja.svg'
// import Logo from '../svg/LogoPixart'
import ModalLogin from '../modals/modalLogin'
import styles from '../../css/index/Header.module.css'
import { Dropdown } from 'primereact/dropdown'
import { useTranslation } from 'react-i18next'
import { config } from '../../config'

export default function Header () {
  const [show, setShow] = useState(false)
  const modalRef = useRef(null)
  const [language, setLenguage] = useState(config?.backend?.language)

  const { i18n } = useTranslation()
  const { t } = useTranslation('index')

  const languages = [
    { name: t('header.español'), value: 'es' },
    { name: t('header.ingles'), value: 'en' }
  ]

  const changeLanguage = (lng) => {
    startTransition(() => {
      i18n.changeLanguage(lng)
    })
  }

  const handleClickOutside = ({ target }) => {
    if (modalRef.current && !modalRef.current.contains(target)) {
      setShow(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <header className={styles.headerMain}>
      <div>
        <img src={Logo} alt="logo" className={styles.logoClm}/>
        {/* <Logo /> */}
      </div>
      <nav className={styles.headerLinks}>
        <ul>
          <li>
            <a href="/">{t('header.inicio')}</a>
          </li>
          <li>
            <a
              href="https://pixartargentina.com.ar/soluciones.html"
              target="_blank"
              rel="noreferrer"
            >
              {t('header.soluciones')}
            </a>
          </li>
          <li>
            <a
              href="https://pixartargentina.com.ar/empresa.html"
              target="_blank"
              rel="noreferrer"
            >
              {t('header.empresa')}
            </a>
          </li>
          <li>
            <a
              href="https://pixartargentina.com.ar/productos.html"
              target="_blank"
              rel="noreferrer"
            >
              {t('header.stock')}
            </a>
          </li>
        </ul>
      </nav>
      <div className={styles.headerContacts}>
        <div>
          <h6>{t('header.email')}:</h6>
          <a
            href="mailto:info@pixartargentina.com.ar"
            target="_blank"
            rel="noreferrer"
          >
            <span>info@pixartargentina.com.ar</span>
          </a>
        </div>
      </div>
      <div className={styles.btn}>
        <Button
          onClick={() => (!show ? setShow(true) : setShow(false))}
          className="boton"
          variant="primary"
        >
          <b>{t('header.acceder')}</b>
        </Button>
        <div className={styles.divLanguage}>
          <i className={`fa-solid fa-earth-americas ${styles.iconLanguage}`}></i>
          <Dropdown
            variant="filled"
            value={language}
            onChange={(e) => {
              setLenguage(e.value)
              changeLanguage(e.value)
            }}
            options={languages}
            optionLabel="name"
            placeholder={t('header.placeholder')}
            className={styles.selectLanguage}
            panelClassName={styles.panelSelectLanguage} />
        </div>
      </div>
      <div
        className={styles.modal}
        style={{
          display: show && show === true ? 'flex' : 'none'
        }}
        ref={modalRef}
      >
        <ModalLogin />
      </div>
    </header>
  )
}
